// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"27d06405","997":"aa48b960"}[chunkId] + ".chunk.css";
};